"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = exports.RadioGroupContext = void 0;
var React = require("react");
exports.RadioGroupContext = React.createContext({
    onSelect: function () { },
});
function RadioGroup(props) {
    var defaultSelection = props.defaultSelection, children = props.children, id = props.id, _a = props.onChange, onChange = _a === void 0 ? function () { } : _a;
    var _b = React.useState(defaultSelection), selected = _b[0], setSelected = _b[1];
    var onSelect = function (value) {
        setSelected(value);
        onChange(value);
    };
    exports.RadioGroupContext.displayName = id + 'SelectionContext';
    React.useEffect(function () {
        setSelected(defaultSelection);
    }, [defaultSelection]);
    return (React.createElement(exports.RadioGroupContext.Provider, { value: {
            onSelect: onSelect,
            selected: selected,
        } }, children));
}
exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/RadioGroup/RadioGroup.js
// module id = 424
// module chunks = 8